import React, { FC, useState, useEffect } from 'react'
import { IonPage, IonContent, useIonViewDidEnter } from '@ionic/react'
import { RouteComponentProps } from 'react-router-dom'
import { observer } from 'mobx-react'
import ActivityApi from '@api/activity.api'
import MemberApi from 'api/member.api'
import { modalLayer, useHistoryNew, checkActiveTime, getPlatform } from '@utils'
import { memberMobx } from '@mobxStore'
import { CouponItem, CouponDetail, TipModal, MktButton } from '@cps'
import { ddayjs } from '@dt/fe-utils'
import mktController from 'controllers/mktController'
import i18n from 'i18next'
import DetailModal from './detail'
import { each } from '@dt/fe-utils/dist/lodash'
import { BackHeader } from 'pages/mkt/components'
import './index.scss'

import codeSendBgImg from '@img/mkt/codeSendBg.jpeg'

const { isWeixinMiniProgram } = getPlatform()

interface IProps extends IPage, RouteComponentProps { }

const CouponModal: FC<IProps> = ({ match }) => {
  const { activityId } = match.params as any
  const history = useHistoryNew()
  const { isLogin, memberInfo } = memberMobx
  const [canGet, setCanGet] = useState<boolean>(false)
  const [isGet, setIsGet] = useState<boolean>(false)
  const [showAll, setShowAll] = useState<boolean>(false)
  const [activeInfo, setActiveInfo] = useState<any>(null)
  const [couponList, setCouponList] = useState<any[]>([])
  const getCoupons = () => {
    if (isLogin) {
      if (isGet) {
        history.replace('/my')
      } else {
        if (memberInfo.type !== 'member') {
          mktController.jumpBind(history, 'all')
        } else {
          memberMobx.acquireActiveCoupons(Number(activityId)).then((res: any) => {
            if (res.error) {
              modalLayer(TipModal, {
                content: i18n.t('mkt.coupon.getFail')
              }).then(() => {
                history.replace('/my')
              })
            } else {
              setIsGet(true)
              modalLayer(TipModal, {
                content: i18n.t('mkt.coupon.getSuccess', { name: activeInfo.activityName })
              }).then(() => {
                history.replace('/my')
              })
            }
          })
        }
      }
    } else {
      history.push('/login')
    }
  }
  const goDetail = (data: any) => {
    modalLayer(CouponDetail, { type: 'get', couponInfo: data }, 'couponDetail')
  }
  useIonViewDidEnter(() => {
    ActivityApi.getActiveDetail(activityId).then((res: any) => {
      if (!res.error) {
        setActiveInfo(res)
      }
    })
    ActivityApi.getActiveCoupons(Number(activityId)).then((res: any) => {
      if (res && res.activity) {
        const listArr: any[] = []
        each(res.coupons, (item: any) => {
          if (item.status === 'enable') {
            for (let i = 0; i < item.couponCnt; i++) {
              listArr.push(item)
            }
          }
        })
        setCouponList(listArr)
        const startTime: any = ddayjs(res.activity.startTime).valueOf()
        const endTime: any = ddayjs(res.activity.endTime).valueOf()
        if (Date.now() < startTime) {
          setCanGet(false)
          modalLayer(TipModal, {
            content: i18n.t('mkt.market.activityNotStart')
          }).then(() => {
            history.replace('/my')
          })
          return
        }
        if (Date.now() > endTime) {
          setCanGet(false)
          modalLayer(TipModal, {
            content: i18n.t('mkt.market.eventIsOver')
          }).then(() => {
            history.replace('/my')
          })
          return
        }
        if (!res.activity.isAllTime && res.activity.timeRanges.length > 0) {
          const checkResult: any = checkActiveTime(res.activity.timeRanges)
          if (!checkResult) {
            setCanGet(false)
            modalLayer(TipModal, {
              content: i18n.t('mkt.market.getCouponsTip1')
            }).then(() => {
              history.replace('/my')
            })
            return
          }
        }
        setCanGet(true)
      } else {
        setCanGet(false)
        modalLayer(TipModal, {
          content: i18n.t('mkt.market.activityNotExist')
        }).then(() => {
          history.replace('/my')
        })
      }
    })
  })
  useEffect(() => {
    if (isLogin && activeInfo && canGet) {
      MemberApi.checkGetCoupons({
        activityId: Number(activityId),
      }).then((res: any) => {
        setIsGet(res.acquired)
        if (res.acquired) {
          let tips = i18n.t('mkt.coupon.hasGetSuccess')
          switch (res.failReason) {
            case 'receivedNum':
              tips = i18n.t('mkt.coupon.couponsCollectOut')
              break
            case 'everyDayReceiveNumber':
              tips = i18n.t('mkt.coupon.daliyCouponsCollectOut')
              break
            case 'total':
              tips = i18n.t('mkt.coupon.personalCollectOut', { n: res.maxNum })
              break
            case 'dayCycle':
              tips = i18n.t('mkt.coupon.personalDaliyCollectOut', { n: res.maxNum })
              break
            default:
              break
          }
          modalLayer(TipModal, {
            content: tips
          }).then(() => {
            history.replace('/my')
          })
        }
      })
    }
  }, [isLogin, activeInfo, canGet])
  useEffect(() => {
    if (activeInfo) {
      let url = `${location.origin}/my/getCoupons/${activityId}?ct=brand&b=${Config.BRANDID}`
      if (isWeixinMiniProgram) {
        url = `/pages/launch/index?jumpH5Page=${encodeURIComponent(url)}`
      }
      mktController.initShareData({
        url: url,
        title: activeInfo.activityName,
        des: activeInfo.extra?.copywriting || '',
        img: activeInfo.playbill,
      })
    }
  }, [activeInfo])
  return (
    <IonPage className='code-coupon-page'>
      <BackHeader title={i18n.t('mkt.market.marketDetail')}>
        <div className='detail-btn' onClick={() => modalLayer(DetailModal, { extra: activeInfo.extra })}>
          <span>{i18n.t('mkt.market.marketDetail')}</span>
          <i className='iconfont icon-chevron-right'></i>
        </div>
      </BackHeader>
      <IonContent className='page-content'>
        {
          activeInfo &&
            <div className='page-body' style={{ backgroundImage: `Url(${activeInfo.playbill || codeSendBgImg})` }}>
              <div className='coupon-body'>
                <div className='coupon-area'>
                  <div className={`coupon-list ${showAll ? 'show-all' : ''}`}>
                    {
                      couponList.map((item: any, index: number) => (
                        <div className='coupon-block' key={index}>
                          <CouponItem type='get' couponInfo={item} onClick={goDetail}></CouponItem>
                        </div>
                      ))
                    }
                  </div>
                  {
                    couponList.length > 3 && !showAll
                      ? (
                        <div
                          className='view-all' onClick={() => {
                            setShowAll(true)
                          }}
                        >
                          {i18n.t('mkt.common.viewAll')}
                        </div>
                      ) : ''
                  }
                  {
                    canGet && !isGet &&
                      <div className='code-coupon-page-footer '>
                        <MktButton onClick={getCoupons}>
                          <span>{isLogin ? i18n.t('mkt.coupon.getCoupons') : i18n.t('mkt.common.loginAccount')}</span>
                        </MktButton>
                      </div>
                  }
                </div>
              </div>
            </div>
        }
      </IonContent>
    </IonPage>
  )
}

export default observer(CouponModal)
